import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "group-list" }
const _hoisted_2 = { class: "groups" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "dot mr-1 h-100 is-success" }, null, -1 /* HOISTED */)
const _hoisted_5 = { class: "mr-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "dot mr-1 h-100 is-danger" }, null, -1 /* HOISTED */)
const _hoisted_7 = { class: "mr-2" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "is-italic pr-2" }
const _hoisted_10 = {
  key: 1,
  class: "center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_station_list_item = _resolveComponent("station-list-item")!
  const _component_n_collapse_item = _resolveComponent("n-collapse-item")!
  const _component_n_collapse = _resolveComponent("n-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.groups !== null && _ctx.groups.length > 0)
        ? (_openBlock(), _createBlock(_component_n_collapse, { key: 0 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
                return (_openBlock(), _createBlock(_component_n_collapse_item, {
                  key: group.id,
                  title: group.label,
                  name: group.name
                }, {
                  "header-extra": _withCtx(() => [
                    (group?.stations?.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _hoisted_4,
                          _createElementVNode("span", _hoisted_5, _toDisplayString(group?.stations?.filter( s=> s.status === 'online').length), 1 /* TEXT */),
                          _hoisted_6,
                          _createElementVNode("span", _hoisted_7, _toDisplayString(group?.stations?.filter( s=> s.status === 'offline').length), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('global.n-stations', group?.stations?.length)), 1 /* TEXT */)
                        ]))
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.stations, (station) => {
                      return (_openBlock(), _createBlock(_component_station_list_item, {
                        key: station.id,
                        station: station,
                        active: _ctx.current?.id === station.id,
                        onOnStationClicked: _ctx.onStationSelected,
                        "onStation:edit": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('station:edit'))),
                        forgettable: false
                      }, null, 8 /* PROPS */, ["station", "active", "onOnStationClicked"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "name"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('group_list.no_groups')), 1 /* TEXT */)
          ]))
    ])
  ]))
}